import React from 'react';
import { Image, Header } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const PageNotFound = props => {
  const { t } = useTranslation();
  let redirect;
  const links = {
    home: { link: '/', text: t('gotoFirstPage') },
    support: { link: '/support', text: t('supportMessage') },
  };
  if (!props.redirectTo) {
    redirect = 'home';
  } else {
    redirect = props.redirectTo;
  }
  return (
    <div className="errorPage">
      <Image className="logo" src={require('../../assets/images/vibinoLogoC.svg')} />
      <Header className="errorTitle" as="h1" content={t('error404')} />
      <span className="message">{t('pageNotFound')}</span>
      <br />
      <a className="redirectLink" href={links[redirect].link}>
        {links[redirect].text}
      </a>
    </div>
  );
};

PageNotFound.propTypes = {
  redirectTo: PropTypes.string,
};

export default PageNotFound;
